import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddEditBannerForm from "../../components/section/banners/AddEditBannerForm";

const EditBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="container_xxl bg-[#eceff1] px-4">
      <div className="flex items-center space-x-4 headingBorder__b sticky top-0 z-10">
        <div>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
        </div>
        <div>
          <h1 className="heading">Edit Banner</h1>
        </div>
      </div>
      
      <AddEditBannerForm isEdit={true} />
    </div>
  );
};

export default EditBanner;
